import {
  Actions,
  Box,
  ButtonLink,
  Heading,
  Stack,
  Text,
} from 'braid-design-system';

import Routes from 'src/config/routes';

export const FreemiumPaymentSuccess = () => (
  <Box data={{ testid: 'freemium-payment-success' }}>
    <Stack space="large">
      <Heading level="3" component="h1">
        Order successful
      </Heading>

      <Stack space="large">
        <Text>Your Free ad is ready to use.</Text>
      </Stack>

      <Actions>
        <ButtonLink href={Routes.DASHBOARD} tone="formAccent">
          Go to dashboard
        </ButtonLink>
      </Actions>
    </Stack>
  </Box>
);
